const endpoint = property => `/api/${property}/events/availability`;
const stockendpoint = property => `/api/${property}/events/quantity`;
const blockendpoint = (property, date) => `/api/${property}/events/blocks/${date}`;

export default ['$rootScope', 'api', function ($rootScope, api) {
    const toQueryString = (obj) => {
        let queryString = [];
        for (let param in obj) {
            if (obj[param]) {
                queryString.push(encodeURIComponent(param) + '=' + encodeURIComponent(obj[param]));
            }
        }
        if (queryString.length) {
            return '?' + queryString.join('&');
        } else {
            return '';
        }
    };

    return {
        save: (availability, type) => {
            let url = availability.id ? `${endpoint(api.property())}/${availability.id}` : endpoint(api.property());

            availability.property_id = api.property();

            return api.upload(url + `?ruletype=${type}`, availability).then(response => response.data);
        },
        delete: (id, filter) => api.delete(`${endpoint(api.property())}/${id}` + toQueryString(filter)),
        findAll: (filter) => {
            return api.get(endpoint(api.property()) + toQueryString(filter)).
                then(response => response.data);
        },
        findById: (id, filter) => {
            return api.get(`${endpoint(api.property())}/${id}` + toQueryString(filter))
                .then(response => response.data);
        },
        search: (filter) => {
            return api.get(endpoint(api.property()) + toQueryString(filter)).
                then(response => response.data);
        },
        updateStock: (item, date) => {
            item.date = date;
            return api.post(`${stockendpoint(api.property())}`, item).then(response => response);
        },
        getStock: (filter) => {
            return api.get(`${stockendpoint(api.property())}` + toQueryString(filter)).then(response => response.data);
        },
        findStock: (filter) => {
            return api.get(stockendpoint(api.property()) + toQueryString(filter)).
                then(response => response.data);
        },
        searchStock: (filter) => {
            return api.get(stockendpoint(api.property()) + toQueryString(filter)).
                then(response => response.data);
        },
        findSingleStock: (id) => {
            return api.get(`${stockendpoint(api.property())}/${id}`)
                .then(response => [response.data]);
        },
        dateStatus: date => {
            return api.get(`${endpoint(api.property())}/${date}/status`)
                .then(response => response.data);
        },
        dateToggle: date => {
            return api.post(`${endpoint(api.property())}/${date}/toggle`)
                .then(response => response.data);
        }
    };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/availability/services/availability.service.js